<template>
  <v-dialog v-model="show" max-width="880">

    <v-card class="dialog-content">
      <v-card-title class="headline">
        <h4>Liberar certificados do curso {{ courseTitle }}</h4>
      </v-card-title>

      <v-card-text v-if="loadingUsers" class="text-center">
        Buscando usuários...
      </v-card-text>

      <v-card-text>
        <v-simple-table
          fixed-header
          height="300px"
        >
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Nome
              </th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="user in users"
              :key="user._id"
            >
              <td>{{ user.name }}</td>
              <td class="text-right">
                <v-btn
                  class="ma-1"
                  small
                  outlined
                  color="indigo accent-4"
                  v-if="!user.certified"
                  :loading="releasing"
                  :disabled="releasing"
                  @click="releaseCertificate(user._id)"
                >
                  Liberar certificado
                </v-btn>
                <v-btn
                  class="ma-1"
                  small
                  outlined
                  color="indigo accent-4"
                  v-if="user.certified"
                  :loading="sending"
                  :disabled="sending"
                  @click="sendCertificate(user.certified)"
                >
                  Enviar por email
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-flex xs12 class="pr-2 pl-2 mb-3" style="text-align:right;">
          <v-btn color="grey" dark @click="show = false" class="mr-2">
            Fechar
          </v-btn>
        </v-flex>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import slugfy from 'slugify'

export default {
  name: 'ModalCertificate',
  data: () => ({
    show: true,
    loadingUsers: false,
    sending: false,
    releasing: false,
    users: []
  }),
  props: {
    courseId: {
      type: String,
      required: true,
    },
    courseTitle: {
      type: String,
      required: true,
    }
  },
  watch: {
    show (value) {
      this.$emit('input', value)
    },
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      this.loadingUsers = true

      this.axios.get(`/user/course/users/${this.courseId}`).then(({ data }) => {
        if (data.success) {
          this.users = data.users
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loadingUsers = false
      })
    },
    releaseCertificate (userId) {
      this.releasing = true

      this.axios.post('/user/certificate/release', { userId, courseId: this.courseId }).then(({ data }) => {
        if (data.success) {
          this.$swal('Sucesso', 'Certificado liberado para o usuário', 'success').then(() => {
            this.getUsers()
          })
        } else {
          this.$swal('Ops', 'Não foi possível liberar o certificado', 'error')
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Não foi possível liberar o certificado', 'error')
      }).finally(() => {
        this.releasing = false
      })
    },
    sendCertificate (certificateId) {
      this.sending = true

      this.axios.post('/user/certificate/send', { certificateId }).then(({ data }) => {
        if (data.success) {
          this.$swal('Sucesso', 'Certificado enviado com sucesso', 'success').then(() => {
            this.getUsers()
          })
        } else {
          this.$swal('Ops', 'Não foi possível enviar o certificado', 'error')
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Não foi possível enviar o certificado', 'error')
      }).finally(() => {
        this.sending = false
      })
    }
  }
}
</script>
